<mat-accordion>
    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
        [expanded]="config?.expanded">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{ config?.keyTitle ? config.keyTitle : 'REFERENCES' | translate}}
            </mat-panel-title>
            <mat-panel-description *ngIf="!config?.hidePanelDes">
                {{'Reduce' | translate}}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="scrollbar-custom" *ngIf="config?.items?.length">
            <div class="body" [ngStyle]="{'height.px': config?.height ? config?.height : 520}">
                <ng-container *ngFor="let item of config?.items; let i = index">
                    <div class="reference-item text-truncate" [ngClass]="{'gray-bg': !item?.s3_key && !config?.keyTitle}"
                        (click)="onShowFile(item.s3_key || item.document, i)">
                        {{item?.name || item?.field_name}} <div *ngIf="commonService?.downloadState[i]" class="spinner-border"></div>
                    </div>
                </ng-container>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>
